import React, { Component } from 'react'
import { Link } from 'gatsby'
import _ from 'lodash'
import { createUrl, createShoeUrl } from '../../utils/url-utils'
import SearchIcon from '../../components/svg/SearchIcon'
import styles from './Search.module.scss'

class Search extends Component {
  state = {
    isSearchShown: false,
    query: '',
    searchResults: [],
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleEscapeClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscapeClick, false)
  }

  disableScroll = () => {
    if (typeof window !== 'undefined') {
      const scrollbarWidth =
        window.innerWidth - window.document.documentElement.clientWidth
      window.document.body.style.paddingRight = `${scrollbarWidth}px`
      window.document.body.style.overflow = 'hidden'
    }
  }

  handleSearchClick = () => {
    this.disableScroll()
    this.setState(
      {
        isSearchShown: true,
      },
      () => this.searchInput.focus()
    )
  }

  handleSearchChange = event => {
    const query = event.target.value
    const searchResults =
      query.length >= 1 ? this.getSearchResults(`${query}* ${query}`) : []
    const fixSearchResults = searchResults.map(item => {
      const {
        legacy,
        legacyTitle,
        category,
        title,
        createdAt,
        slug,
        shoeName,
      } = item
      item.url = !shoeName
        ? createUrl(legacy, legacyTitle, category, title, createdAt, slug)
        : createShoeUrl(slug, title)
      return item
    })

    const filteredSearchResults = _.uniqBy(fixSearchResults, 'url').filter(
      ({ url }) => !!url
    )

    this.setState(s => {
      return {
        ...s,
        searchResults: filteredSearchResults,
        query,
      }
    })
  }

  handleEscapeClick = event => {
    if (event.keyCode === 27) {
      this.handleCloseClick()
    }
  }

  handleCloseClick = () => {
    window.document.body.style.paddingRight = `0px`
    window.document.body.style.overflow = 'auto'
    this.setState(
      {
        query: '',
        searchResults: [],
        isMenuShown: false,
        isSearchShown: false,
      },
      () => (this.searchInput.value = '')
    )
  }

  getSearchResults(query) {
    if (!query || !window.__LUNR__) return []
    const lunrIndex = window.__LUNR__['en']
    const results = lunrIndex.index.search(query)
    return results.map(({ ref }) => lunrIndex.store[ref])
  }

  render() {
    const { searchResults } = this.state

    return (
      <div className={styles.root}>
        <div
          className={styles.search}
          onClick={this.handleSearchClick}
          tabIndex="0"
        >
          <SearchIcon width="20px" height="20px" className={styles.share} />
        </div>
        <div
          className={
            this.state.isSearchShown
              ? styles.overlayShown
              : styles.overlayHidden
          }
        >
          <div className={styles.content}>
            <button className={styles.close} onClick={this.handleCloseClick}>
              ✕
            </button>
            <input
              type="text"
              placeholder="I'm looking for..."
              className={styles.searchInput}
              onChange={this.handleSearchChange}
              ref={input => {
                this.searchInput = input
              }}
              aria-label="search"
            />
            <div className={styles.searchResults}>
              <ul className={styles.searchResultsList}>
                {searchResults.map(({ title, url }) => (
                  <li
                    key={url}
                    className={styles.searchResultsItem}
                    onClick={this.handleCloseClick}
                  >
                    <Link to={url}>{title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Search
